import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import {
  Box,
  IconButton,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Edit } from "../../../../../assets/images/edit.svg";
import CustomPagination from "../../../../../components/CustomPagination";
import Modal from "../../../../../components/Modal";
import styles from "./style";
import { getDateFormat } from "../../../../../utils/dateFormatStore";

const RecurringTemplateList = ({
  total,
  page,
  setPage,
  data,
  handleDeleteRecurringTemplate,
}) => {
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [item, setItem] = useState(null);
  const [opens, setOpens] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleNavigate = () => {
    // Use the latest item state
    if (item) {
      navigate("/dashboard/editRecurringTemplate", { state: { item } });
      setAnchorEl(null);
    }
  };

  const handleNavigateView = () => {
    if (item) {
      navigate("/dashboard/recurringTemplate", { state: { item } });
      setAnchorEl(null);
    }
  };

  const handleClick = (event, rowItem) => {
    setItem(rowItem);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteData = (recurringTemplateId) => {
    setDeleteId(recurringTemplateId);
    setAnchorEl(null);
    setOpens(true);
  };

  const handleDeleteItem = () => {
    handleDeleteRecurringTemplate(deleteId);
    setOpens(false);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Customer Name</TableCell>
              <TableCell sx={styles.TableHead}>Profile Name</TableCell>
              <TableCell sx={styles.TableHead}>Frequency</TableCell>
              <TableCell sx={styles.TableHead}>Last Invoice Date</TableCell>
              <TableCell sx={styles.TableHead}>Next Invoice Date</TableCell>
              <TableCell sx={styles.TableHead}>Amount</TableCell>
              <TableCell sx={styles.TableHead}>Status</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No Data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tabledata}>
                    {item?.customerName}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {item?.profileName}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {item?.repeatEvery}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {dayjs(item?.lastInvoiceDate).format(getDateFormat())}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {dayjs(item?.nextInvoiceDate).format(getDateFormat())}
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    {item?.grandTotal.toFixed(2)}
                  </TableCell>
                  <TableCell sx={{ borderBottom: 0 }}>
                    <Box
                      sx={{
                        border: `1px solid ${
                          item.status === "Active"
                            ? "#28AA4A"
                            : item.status === "Expired"
                            ? "#878787"
                            : item.status === "Cancelled"
                            ? "#E93030"
                            : "black"
                        }`,
                        borderRadius: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        py: "3px",
                        px: "14px",
                        width: "fit-content",
                        fontSize: "12px",
                        color: `${
                          item.status === "Active"
                            ? "#28AA4A"
                            : item.status === "Expired"
                            ? "#878787"
                            : item.status === "Cancelled"
                            ? "#E93030"
                            : "black"
                        }`,
                      }}
                    >
                      {item?.status}
                    </Box>
                  </TableCell>
                  <TableCell sx={styles.tabledata}>
                    <Box sx={styles.tableActiondata}>
                      <IconButton onClick={(e) => handleClick(e, item)}>
                        <MoreVertIcon />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        <CustomPagination
          pageCount={total}
          totalItems={total}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        />
      </TableContainer>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Box sx={{ p: 2, pr: 6 }}>
          <Box>
            <Box sx={styles.iconGrid} onClick={handleNavigate}>
              <Box sx={styles.iconSvg}>
                <Edit />
              </Box>
              <Box sx={styles.iconText}>Edit</Box>
            </Box>
          </Box>
          <Box onClick={handleClose}>
            <Box sx={styles.iconGrid} onClick={handleNavigateView}>
              <Box>
                <RemoveRedEyeOutlinedIcon sx={styles.icon} />
              </Box>
              <Box sx={styles.iconText}>View</Box>
            </Box>
          </Box>

          <Box onClick={() => deleteData(item?._id)}>
            <Box sx={styles.iconGrid}>
              <Box>
                <DeleteOutlineIcon sx={styles.icon} />
              </Box>
              <Box sx={styles.iconText}>Delete</Box>
            </Box>
          </Box>
        </Box>
      </Popover>

      <Modal
        open={opens}
        setOpen={setOpens}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Recurring Invoice"}
        handleDelete={handleDeleteItem}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};
export default RecurringTemplateList;
